import { compose, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import HeaderView from './HeaderView';
import { signOut } from '../../pages/login/LoginState';
import { toggleSidebar } from '../Layout/LayoutState';
export default compose(
  connect(
    (state) => ({
      isSidebarOpened: state.layout.isSidebarOpened,
    }),
    { signOut, toggleSidebar },
  ),
  withState('warningMenu', 'setWarningMenu', null),
  withState('mailMenu', 'setMailMenu', null),
  withState('isWarningUnread', 'setisWarningUnread', true),
  withState('profileMenu', 'setProfileMenu', null),
  withState('isMailsUnread', 'setIsMailsUnread', true),
  withHandlers({
    openMailMenu: (props) => (event) => {
      props.setMailMenu(event.currentTarget);
      props.setIsMailsUnread(false);
    },
    closeMailMenu: (props) => () => {
      props.setMailMenu(null);
      props.setIsMailsUnread(true);
    },
    openWarningMenu: (props) => (event) => {
      props.setWarningMenu(event.currentTarget);
      props.setisWarningUnread(false);
    },
    closeWarningMenu: (props) => () => {
      props.setWarningMenu(null);
    },
    openProfileMenu: (props) => (event) => {
      props.setProfileMenu(event.currentTarget);
    },
    closeProfileMenu: (props) => () => {
      props.setProfileMenu(null);
    },
  }),
)(HeaderView);
